import React from 'react';
import { Container, Col, Row, Image, Card, Button } from 'react-bootstrap';
import { Logo } from '../components';

export const ContainerComm = (props: any) => {
  const handleClick = () => {
    window.open(`/`, '_self');
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div style={{ textAlign: 'center' }}>
        <Logo
          logoURL={
            'https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png'
          }
        />

        <Card className="p-4 shadow mt-3" style={{ width: '70vw' }}>
          <Col>
            <Row className="mb-3">
              <Col xs={12}>
                <Image
                  src={'https://i.ibb.co/YTcSTsT/success-wp-1.png'}
                  height={100}
                  style={{ marginBottom: '20px' }}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h5 style={{ fontWeight: '500' }}>
                  Your response is already recorded.
                </h5>
                <h6 style={{ fontWeight: '500' }}>Thank You!</h6>
              </Col>
            </Row>

            <Button
              variant="primary"
              onClick={handleClick}
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              }}
            >
              Go Back
            </Button>
          </Col>
        </Card>
      </div>
    </Container>
  );
};
